export const tutorialAssets = {
	shine: "/spec_tutorial/shine.png",
	char1: "/spec_tutorial/char-1.png",
	char2: "/spec_tutorial/char-2.png",
	background: "/spec_tutorial/background.svg",
	greenArrow: "/spec_tutorial/icon_greenArrow.png",
	purchaseStep1: "/spec_tutorial/purchase-step01.png",
	purchaseStep2: "/spec_tutorial/purchase-step02.png",
	firstPurchaseBg: "/spec_tutorial/first-purchase-background.jpg"
} as const;
